// Install styled-components first by running: npm install styled-components
import React from "react";
import styled from "styled-components";
import { StyledButton } from "../components/Styles";
import { useTranslation } from "react-i18next";


const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60vh;
  /* min-height: calc(100vh - 260px); */
`;

const FormWrapper = styled.div`
  background: #f5f5ef;
  padding: 2rem;
  margin-top: 100px;
  /* border: 0.1px solid black; */
  border-radius: 10px;
  /* box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1); */
  width: 100%;
  max-width: 500px;
`;

const Title = styled.h2`
  margin-bottom: 1.5rem;
  text-align: center;
  font-size: 1.5rem;
  color: #333333;
`;

const Input = styled.input`
  width: 100%;
  padding: 0.75rem 1rem;
  margin-bottom: 1rem;
  border: 1px solid #ddd;
  border-radius: 5px;
  font-size: 1rem;
  transition: all 0.3s ease;

  &::placeholder {
    font-size:18px;
    opacity:0.7;
    font-family: ${(props) => props.lang === "fa" ? "Tanha, sans-serif" : "Purisa, sans-serif"};
    text-align: ${(props) => props.lang === "fa" ? "right" : "left"};
  }

  text-align: left;
  &:focus {
    border-color: #007bff;
    outline: none;
  }
`;


const Signin = () => {

  const { t, i18n } = useTranslation();

  const handleSubmit = (e) => {
    e.preventDefault();
  };


  return (
    <Container>
      <FormWrapper>
        <Title>{t("login")}</Title>
        <form onSubmit={handleSubmit}>
          <Input type="text" placeholder={t("username")} required lang={i18n.language} />
          <Input type="password" placeholder={t("password")} required lang={i18n.language} />
          <StyledButton.Main>{t("login")}</StyledButton.Main>
        </form>
        {/* <Link to="/contact-us">
          <StyledLink>Forgot Password? Contact Us</StyledLink>
        </Link> */}
      </FormWrapper>
    </Container>
  );
};

export default Signin;
